// extracted by mini-css-extract-plugin
module.exports = {"borderGrey":"#B5B4B5","zIndexModalBackdrop":"1040","settings":"_1kzOcs5kJiZSpKoD","title":"TfS1uXP8PoHUhrBq","subtitle":"_2zIMmZnOIzY3i79Y","error":"_1HsbSGaxnj8vEBsE"};